module.exports = __webpack_public_path__ + "static/media/dealtNoTrumps_1.b62b96bf.svg";